import React from "react";
import FlexText from "../../flexText";
import CircleHlt from "./circleHlt";
import Styles from "./styles/style";

export const replaceP = (string) => {
  if (typeof string === 'undefined') {
    return string;
  }
  return string.replace(/<\/?[^>]+(>|$)/g, "")
}

const Fact = ({ item }) => (
  <div className="factoid" tabIndex="-1">
    <CircleHlt>
      <FlexText
        classes="hiltText"
        tag="p"
        max="72"
        min="50"
        color="#01533F"
        className="circleFacts"
        styles={{
          textTransform: "uppercase",
          fontFamily: "Oswald",
          color: "#007155",
          textAlign: "center",
          lineHeight: "80px",
          fontWeight: "500",
          position: "absolute",
          clear: "both",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)"
        }}
      >
        {item.field_text_1}
      </FlexText>
    </CircleHlt>
    <div style={{ width: "230px", margin: "24px auto" }}>
      <FlexText
        classes="HiltText factoidLongText1"
        tag="p"
        max="18"
        min="14"
        styles={{
          ...Styles.faqHiltTextCircle
        }}
      >
        {replaceP(item.field_longtext_1)}
      </FlexText>
      <FlexText
        classes="factText factoidLongText2"
        tag="p"
        max="16"
        min="14"
        styles={{
          color: "#01533F",
          lineHeight: "24px",
          display: "inline-block",
          fontFamily: "Roboto",
          textAlign: "center",
          fontWeight: "500",
          textTransform: "lowercase"
        }}
      >
        {replaceP(item.field_longtext_2)}
      </FlexText>
    </div>
  </div>
);

export default Fact;
